import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MobileAllMenu.style.css';
//import { DepthMenu } from 'components';
import MobileRecursiveMenu from '../MobileRecursiveMenu';

const MobileAllMenu = ({ setIsAllOpen, menus }) => {
  const navigate = useNavigate(); // React Router 네비게이션 훅
  const location = useLocation(); // 현재 경로를 가져옴
  const [forceCloseMenus, setForceCloseMenus] = useState(false);

  // 메뉴가 열릴 때마다 forceClose 값을 바꿔서 트리거 발생
  React.useEffect(() => {
    setForceCloseMenus(true); // 일단 닫음
    const timer = setTimeout(() => setForceCloseMenus(false), 50); // 바로 다시 false로
    return () => clearTimeout(timer);
  }, [menus]);

  /* const menuItems = [
    {
      title: 'Best Sellers',
      path: '/products?type=best',
    },
    {
      title: 'New Products',
      path: '/products?type=new',
    },
    //{
    //  title: 'Promotions',
    //  path: '/products?type=promotions',
    //},
    {
      title: 'Brand',
      path: `/products?classification=brand`,
    },
    //{
    //  title: 'Regular Delivery',
    //  path: '/products?type=subscription',
    //},
    {
      title: 'Gift',
      path: '/products?type=present',
    },
    //{
    //  title: 'JM Event',
    //  path: '/events',
    //},
    // {
    //   title: 'Recipe',
    //   path: '/products?category=recipe',
    // },
  ]; */

  return (
    <div className={`mobile-all-menu`}>
      {/* <div className="inner">
        <ul>
          {menuItems.map((item, index) => (
            <li
              key={`top_menu_${index}`}
              className={
                location.pathname === item.path ? 'active-menu-item' : ''
              }
              onClick={() => {
                navigate(item.path); // 페이지 이동
                setIsAllOpen(false);
              }}
            >
              {item.title}
            </li>
          ))}
        </ul>
      </div> */}
      <div className="inner">
        <ul>
          {menus.map((_item, _index) => (
            <li
              key={`menu_${_index}`}
              onClick={() => {
                setIsAllOpen(false);
              }}
            >
              <MobileRecursiveMenu item={_item} forceClose={forceCloseMenus} />
              {/* <DepthMenu item={_item} /> */}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MobileAllMenu;
